// FILE: frontend/src/components/TranscriptPanel.jsx
// Chat-style transcript with avatars (Patricia's design)
// Renders from a unified timeline array for proper interleaving:
//   { kind: 'assistant', text }  → purple AI bubble (left)
//   { kind: 'user', text }      → orange user bubble (right)
//   { kind: 'score', score }    → inline score card
//   { kind: 'goal', text }      → goal completion toast

import React, { useEffect, useRef } from 'react'
import ScoreCard from './ScoreCard'

export default function TranscriptPanel({ timeline, showScores }) {
  const messagesEndRef = useRef(null)

  // Auto-scroll to bottom on new entries
  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' })
  }, [timeline])

  // Empty state
  if (!timeline || timeline.length === 0) {
    return (
      <div className="sqa-messages">
        <div className="sqa-empty-state">
          Waiting for the conversation to start...
        </div>
      </div>
    )
  }

  return (
    <div className="sqa-messages">
      {timeline.map((entry, idx) => {
        switch (entry.kind) {

          case 'assistant':
            return (
              <div key={`tl-${idx}`} className="sqa-message ai">
                <div className="msg-avatar">🤖</div>
                <div className="msg-body">
                  <div className="msg-sender">Teacher</div>
                  <div className="msg-bubble">{entry.text}</div>
                </div>
              </div>
            )

          case 'user':
            return (
              <div key={`tl-${idx}`} className="sqa-message user">
                <div className="msg-avatar">👤</div>
                <div className="msg-body">
                  <div className="msg-sender">You</div>
                  <div className="msg-bubble">{entry.text}</div>
                </div>
              </div>
            )

          case 'score':
            return (
              <ScoreCard
                key={`tl-${idx}`}
                score={entry.score}
                visible={showScores}
              />
            )

          case 'goal':
            return (
              <div key={`tl-${idx}`} className="goal-toast">
                🎯 Goal complete — {entry.text}
              </div>
            )

          default:
            return null
        }
      })}

      <div ref={messagesEndRef} />
    </div>
  )
}
